import { i18n } from '@/common/utils/i18n'
import VueI8n from '@/i18n/locale'
import { MXSameCountryGroup } from '@/config/visit/addvisit/config.js'

// 拜访内容弹窗 配置 新增
const list = [
  {
    value: 1,
    content: i18n.gettext('电话预约'),
    showFn ({status, way}) {
      return ['follow', 'draft', 'auditing', 'auditFail', 'audited', 'approved', 'signature'].includes(status) && (way !== 'offline')
    }
  },
  {
    value: 7,
    content: i18n.gettext('陌拜'),
    showFn ({showStatus}) {
      return [
        'JP_follow_offline',
        'JP_draft_offline',
        'JP_auditing_offline',
        'JP_auditFail_offline'
      ].includes(showStatus)
    }
  },
  {
    value: 6,
    content: i18n.gettext('正式拜访'),
    showFn ({showStatus}) {
      return [
        'JP_follow_offline',
        'JP_draft_offline',
        'JP_auditing_offline',
        'JP_auditFail_offline'
      ].includes(showStatus)
    }
  },
  {
    value: 5,
    content: VueI8n.t('FoodOpB_1_Information_gathering_pIHo' /** 信息收集 */),
    showFn ({country, way}) {
      return country === 'JP' && way === 'offline'
    }
  },
  {
    value: 2,
    content: i18n.gettext('合作谈判'),
    showFn ({country, status}) {
      return MXSameCountryGroup.includes(country) && ['follow', 'draft', 'auditing', 'auditFail', 'audited', 'approved', 'signature'].includes(status)
    }
  },
  {
    value: 3,
    content: i18n.gettext('设备铺设'),
    showFn ({country, status, way}) {
      return MXSameCountryGroup.includes(country) && ['signed'].includes(status) && way === 'offline'
    }
  },
  {
    value: 4,
    content: i18n.gettext('日常维护'),
    showFn ({country, status, showStatus}) {
      return (MXSameCountryGroup.includes(country) && ['signed'].includes(status))
        || ['JP_signed_online', 'JP_signed_offline', 'JP_signed_WhatsApp', 'JP_signed_email', 'JP_signed_message'].includes(showStatus)
    }
  }
]
const map = {}
list.forEach(item => {
  map[item.value] = item.content
})
export let contentMap = map

export function getVisitContentConfig (showStatus) {
  let arr = showStatus.split('_')
  const obj = {
    country: arr[0],
    status: arr[1],
    way: arr[2],
    showStatus: arr.splice(0, 3).join('_')
  }
  return list.filter(item => {
    return !item.showFn ? true : item.showFn(obj)
  })
}
